import { SET_SHG_TRAINING_VIEW } from "../type";

export const setShgTrainingView = (viewName: string) => (dispatch: any) => {
    dispatch({
        type: SET_SHG_TRAINING_VIEW,
        payload: {
            viewName: viewName
        }
    })
}
